import {Button, ButtonGroup, closeCurrentDialog, MultiChoice} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useState} from 'react';

import {AddableTitleExtensionFeature} from '@dms/api/sales';
import i18n from '@dms/i18n';

interface AddEquipmentFormProps {
  items: AddableTitleExtensionFeature[];
  onAdd: (featureKeys: string[]) => void;
}

export function AddEquipmentForm(props: AddEquipmentFormProps) {
  const [featureKeys, setFeatureKeys] = useState<string[]>([]);

  const handleAdd = () => {
    props.onAdd(featureKeys);
    closeCurrentDialog();
  };

  return (
    <VStack spacing={6}>
      <MultiChoice
        value={featureKeys}
        onChange={(values) => setFeatureKeys(values ?? [])}
        label={i18n.t('entity.newVehicle.labels.equipment')}
        placeholder={i18n.t('entity.newVehicle.authoring.searchEquipment')}
        options={props.items.map((item) => ({label: item.name, value: item.featureKey}))}
        hasOptionCheckbox
        menuInPortal
        isSearchable
      />

      <ButtonGroup align="right">
        <Button
          type="button"
          variant="secondary"
          title={i18n.t('general.actions.cancel')}
          onClick={closeCurrentDialog}
        />
        <Button
          type="button"
          variant="primary"
          title={i18n.t('entity.newVehicle.catalogue.addEquipment')}
          onClick={handleAdd}
          isDisabled={featureKeys.length === 0}
        />
      </ButtonGroup>
    </VStack>
  );
}
